import { render, staticRenderFns } from "./RemoveShift.vue?vue&type=template&id=80af4c74&scoped=true&"
import script from "./RemoveShift.vue?vue&type=script&lang=js&"
export * from "./RemoveShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80af4c74",
  null
  
)

export default component.exports